import React, { useEffect, useState, useCallback } from 'react';
import { actions } from '../../state/actions';
import { connect } from 'react-redux';
import {
  WithSpinner,
  TableAdmin,
  TableRow,
  TableCell,
  Button,
  MultiSelect,
} from '../../components';
import { Link } from 'react-router-dom';
import {
  StatusesStats,
  projectName,
  requestStatusForStats,
} from './../../utils/translation/translation';
import { formatNumberStats } from '../../utils/helpers/helpers';

const BackofficeStats = ({ dispatch, statsState }) => {
  useEffect(() => {
    // dispatch(actions.backoffice.getStatsAction([1, 2]));
  }, []);

  const totalsTableHeader = [
    'Rengiamos paraiškos, vnt.',
    'Pateikta vertinti (vakar)',
    'Atmesta sistemos',
    'Pateikta vertinti (nuo priemonės pradžios)',
  ];

  const requestsTableHeader = [
    'Būsena',
    'Paraiškų skaičius, vnt.',
    'Prašoma paskolos suma',
    'Paskolos suma',
  ];

  const requestsTableHeader2 = [
    'Sprendimas',
    'Paraiškų skaičius, vnt.',
    'Prašoma paskolos suma',
    'Paskolos suma',
    //'Pateiktų mokėjimo prašymų suma',
  ];

  const requestsTableHeader3 = [
    'Skirta priemonei suma',
    'Rezervuota priemonės suma',
    'Likutis',
  ];

  const [projectId, setProjectId] = useState([]);

  const options = [
    { label: 'Karo paskolos', value: 1 },
    //{ label: 'Projektas Pimpackiukas', value: 2 },
  ];

  const onMultiSelectChange = (event) => {
    setProjectId(event);
    const filter = event.map((val) => val.value);
    dispatch(actions.backoffice.getStatsAction(filter));
  };

  {
    /*} const findById = (id, data) => {
    return data?.find((val) => val.RequestStatusId === id);
  };
*/
  }
  const findById = (id) =>
    statsState?.data?.Requests.find((val) => val.Name === id);
  console.log(statsState?.data);
  return (
    <WithSpinner loading={statsState.loading}>
      <div style={{ width: '80%', marginLeft: '10%' }}>
        <h2 style={{ marginTop: '1rem' }}>Statistika</h2>
        <div style={{ display: 'flex' }}>
          <h4 style={{ marginTop: '10px', width: '300px' }}>
            Pasirinkite Priemonę:{' '}
          </h4>{' '}
          <span> </span>
          <div style={{ width: '100%' }}>
            <MultiSelect
              placeholder={'Pasirinkite priemonę'}
              onChange={(e) => onMultiSelectChange(e)}
              value={projectId || ''}
              options={options}
            />
          </div>
        </div>
        <Link
          to="/backoffice/main"
          style={{
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          <Button type="standart">Paraiškų sąrašas</Button>
        </Link>
        {statsState?.data?.length &&
          statsState?.data?.map((val, i) => (
            <>
              <h4 style={{ marginTop: '60px' }}>
                {projectName(val?.ProjectId)}
              </h4>
              <p style={{ fontSize: '16px', marginTop: '40px' }}>Paraiškos</p>

              <TableAdmin header={requestsTableHeader} isEmpty={false}>
                {statsState &&
                  val &&
                  val?.Requests?.map(
                    ({ Count, Name, InvegaLoanSum, LoanSum }) =>
                      Name !== 'NegativeDecision' &&
                      Name !== 'PositiveDecision' && (
                        <TableRow>
                          <TableCell>
                            <span
                              style={{
                                fontWeight:
                                  Name === 'Created' ||
                                  Name === 'Evaluating' ||
                                  Name === 'Submitted'
                                    ? 'bold'
                                    : 'normal',
                              }}
                            >
                              {' '}
                              {StatusesStats(Name)}{' '}
                            </span>
                          </TableCell>
                          <TableCell>{Count}</TableCell>
                          <TableCell>{formatNumberStats(LoanSum)}</TableCell>
                          <TableCell>
                            {formatNumberStats(InvegaLoanSum)}
                          </TableCell>
                        </TableRow>
                      )
                  )}
              </TableAdmin>

              <p style={{ fontSize: '16px', marginTop: '40px' }}>Sprendimai</p>
              <TableAdmin header={requestsTableHeader2} isEmpty={false}>
                {statsState &&
                  val &&
                  val?.Requests?.map(
                    ({ Count, Name, InvegaLoanSum, LoanSum }) =>
                      (Name === 'NegativeDecision' ||
                        Name === 'PositiveDecision') && (
                        <TableRow>
                          <TableCell>
                            <span
                              style={{
                                fontWeight:
                                  Name !== 'Created' ||
                                  Name !== 'Evaluating' ||
                                  Name !== 'Submitted'
                                    ? 'bold'
                                    : 'normal',
                              }}
                            >
                              {' '}
                              {StatusesStats(Name)}{' '}
                            </span>
                          </TableCell>
                          <TableCell>{Count}</TableCell>
                          <TableCell>{formatNumberStats(LoanSum)}</TableCell>
                          <TableCell>
                            {formatNumberStats(InvegaLoanSum)}
                          </TableCell>
                        </TableRow>
                      )
                  )}
              </TableAdmin>
              {console.log(val)}
              <p style={{ fontSize: '16px', marginTop: '40px' }}>Likučiai</p>
              <TableAdmin header={requestsTableHeader3} isEmpty={false}>
                {statsState && val && val?.Totals && (
                  <TableRow>
                    <TableCell>
                      {formatNumberStats(val?.Totals?.MaxSum)}
                    </TableCell>
                    <TableCell>
                      {formatNumberStats(val?.Totals?.Rezerved)}
                    </TableCell>
                    <TableCell>
                      {formatNumberStats(val?.Totals?.Reminder)}
                    </TableCell>
                  </TableRow>
                )}
              </TableAdmin>
            </>
          ))}
        {/*<p>* rezervuota apima priimtus teigiamus sprendimus ir dar neįvertintų paraiškų prašomą sumą</p>*/}
        <br />
        <br />
      </div>
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  statsState: state.backofficeStatsState,
});

export default connect(mapStateToProps)(BackofficeStats);
